<template>
    <div class="printOrderDetails">
        <!-- 订单状态 -->
        <div class="detailsState">
            <div class="detailsState_one">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <p class="detailsState_one_title">订单状态</p>
                <span v-if="processStatus==='UN_CONFIRM'">您已下单，待商家确认</span>
                <span v-if="processStatus==='UN_PAY'">商家已确认，待付款</span>
                <span v-if="processStatus==='OFFLINE_UN_CONFIRM'">线下支付待确认</span>
                <span v-if="processStatus==='DELIVERY_ON_CASH_UN_CONFIRM'">货到付款待确认</span>
                <span v-if="processStatus==='UN_SEND'">您已付款，待商家发货</span>
                <span v-if="processStatus==='UN_RECEIVE'">商家已发货，待您确认</span>
                <span v-if="processStatus==='UN_APPRAISE'">交易已成功</span>
                <span v-if="processStatus==='UN_CANCEL'">交易关闭</span>
            </div>
            <div class="detailsState_one">
                <p v-if="processStatus==='UN_CONFIRM'">
                    商家在{{day}}天{{hr}}小时{{min}}分{{sec}}秒内未确认，则系统将自动取消订单
                </p>
                <p v-if="processStatus==='UN_PAY'">
                    请在{{day}}天{{hr}}小时{{min}}分{{sec}}秒内付款，若未及时付款，系统将自动取消订单
                </p>
                <p v-if="processStatus==='OFFLINE_UN_CONFIRM'">
                    您可以通过消息联系商家确认支付结果
                </p>
                <p v-if="processStatus==='DELIVERY_ON_CASH_UN_CONFIRM'">
                    您可以通过消息联系商家确认支付方式
                </p>
                <p v-if="processStatus==='UN_SEND'">
                    您可以通过消息联系商家确认发货时间
                </p>
                <p v-if="processStatus==='UN_RECEIVE'">
                    您还有{{day}}天{{hr}}小时{{min}}分{{sec}}秒来确认收货，超时订单自动确认收货
                </p>
                <p v-if="processStatus==='UN_APPRAISE'">
                    交易已成功，请给商家评价
                </p>
                <p v-if="processStatus==='UN_CANCEL'">
                    买家取消订单，原因:{{ cancelReason }}
                </p>
            </div>
        </div>
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <div class="processItem" v-if="processStatus!=='UN_CANCEL' && orderBase.payType == 'OFFLINE_PAY' && orderBase.payChannel == 'TRANSFER'" v-for="(item,index) in processList1" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processStatus!=='UN_CANCEL' && orderBase.payType == 'DELIVERY_ON_CASH' && orderBase.payChannel == 'DELIVERY_ON_CASH'" v-for="(item,index) in processList2" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processStatus!=='UN_CANCEL' && orderBase.payType !== 'OFFLINE_PAY' && orderBase.payChannel !== 'TRANSFER' && orderBase.payType !== 'DELIVERY_ON_CASH' && orderBase.payChannel !== 'DELIVERY_ON_CASH'" v-for="(item,index) in processList" :key="index">
                    <div :class="processStatus === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
            </div>
            <!--收货/发票信息-->
            <div class="basicInformation">
                <div class="goodsReceiving">
                    <h3>收货信息</h3>
                    <div class="goodsItem">
                        <div class="name">收货地址：</div>
                        <div class="content">{{ payeeDetail.province }}{{ payeeDetail.city }}{{ payeeDetail.district }}{{ payeeDetail.areaInfo }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">收货人：</div>
                        <div class="content">{{ payeeDetail.receiverName }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">手机号码：</div>
                        <div class="content">{{ payeeDetail.mobile }}</div>
                    </div>
                </div>
                <div class="invoiceInformation" v-if="issueInvoice">
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">发票要求：</div>
                        <div class="content">{{ issueInvoice.issueType=='ZZFP'?'纸质发票':'电子发票' }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">发票类型：</div>
                        <div class="content">{{ invoiceInfo.invoiceType=='NORMAL'?'增值税普通发票':'增值税专用发票' }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">开票信息：</div>
                        <div class="content">{{ invoiceInfo.title }}
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click">
                                <div class="billingInformation ">
                                    <div class="title">开票信息</div>
                                    <div class="billingContent">
                                        <div class="billingItem">
                                            <div class="name">开票抬头：</div>
                                            <div class="content">{{ invoiceInfo.title }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.billType=='ENTERPRISE'">
                                            <div class="name">纳税人识别号：</div>
                                            <div class="content">{{ invoiceInfo.code }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">地址：</div>
                                            <div class="content">{{ invoiceInfo.address }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">电话：</div>
                                            <div class="content">{{ invoiceInfo.mobile }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">开户行：</div>
                                            <div class="content">{{ invoiceInfo.bank }}</div>
                                        </div>
                                        <div class="billingItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                                            <div class="name">账号：</div>
                                            <div class="content">{{ invoiceInfo.bankAccount }}</div>
                                        </div>
                                    </div>
                                </div>
                                <el-button type="text"  slot="reference" style="padding: 0 0 0 10px;">详细</el-button>
                            </el-popover>
                        </div>
                    </div>
                    <!--邮寄地址和电子邮箱根据发票类型显示其中一个-->
                    <div class="goodsItem" v-if="issueInvoice.issueType=='ZZFP'">
                        <div class="name">发票邮寄地址：</div>
                        <div class="content">{{ payeeInfo.province }}{{ payeeInfo.city }}{{ payeeInfo.district }}{{ payeeInfo.areaInfo }}</div>
                    </div>
                    <div class="goodsItem" v-else>
                        <div class="name">电子邮箱：</div>
                        <div class="content">{{ invoiceInfo.payeeEmail }}</div>
                    </div>
                </div>
                <div v-else>
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">暂未开具发票</div>
                    </div>
                </div>
            </div>
            <!--物流信息-->
            <div class="logisticsInformation">
                <h3>物流信息</h3>
                <div class="logisticsContent">
                    <div class="logisticsLeft">
                        <div class="orderItem" v-show="logisticsTrackVisible">
                            <div class="content">暂无物流信息</div>
                        </div>
                        <el-timeline v-show="!logisticsTrackVisible&&logisticsList.length>0">
                            <el-timeline-item :class="index === 0?'timelineItemActive':''" :timestamp="item.ftime" :color="index === 0?'#1890FF':'#B2B2B2'" placement="top" v-for="(item,index) in logisticsList" :key="index">
                                <div class="timelineItemClass">
                                    <el-button class="newest" v-if="index === 0">最新</el-button>
                                    <div class="content">{{item.context}}</div>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                        <div class="orderItem" v-show="!logisticsTrackVisible&&logisticsList.length==0">
                            <div class="content">{{ logisiticsResult }}({{ orderBase.logisticsUuid }}-{{ orderBase.logisticsNo }})</div>
                        </div>
                    </div>
                    <div class="logisticsRight"></div>
                </div>
            </div>
            <!--订单信息-->
            <div class="orderInformation">
                <div class="orderTop">
                    <h3>订单信息</h3>
                    <div class="orderItem">
                        <div class="name">服务商：</div>
                        <div class="content">{{ printOrderInfo.enterPriseName }} <i class="iconfont icon-weixin" @click="startChat(printOrderInfo.enterPriseId)"></i></div>
                    </div>
                </div>
                <div class="orderBottom">
                    <div class="orderItem">
                        <div class="name">订单编号：</div>
                        <div class="content">{{ orderBase.orderNo }}</div>
                    </div>
                    <div class="orderItem">
                        <div class="name">创建时间：</div>
                        <div class="content">{{ orderBase.createDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payChannel!=null && orderBase.payType!=null">
                        <div class="name">付款时间：</div>
                        <div class="content">{{ orderBase.payDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payChannel!=null && orderBase.payType!=null">
                        <div class="name">付款渠道：</div>
                        <div class="content">
                            {{ orderBase.payChannelCn }}
                        </div>
                    </div>
                    <div class="orderItem">
                        <div class="name">备注：</div>
                        <div class="content">{{ orderBase.remark }}</div>
                    </div>
                </div>
            </div>
            <!--打印信息-->
            <div class="printInformation">
                <h3>打印信息</h3>
                <div class="printTableContent">
                    <div class="tableHeader">
                        <div class="sort">序号</div>
                        <div class="name">模型名称</div>
                        <div class="explain">打印说明</div>
                        <div class="price">单价</div>
                        <div class="num">打印数量</div>
                    </div>
                    <div class="tableBody">
                        <div class="sort">
                            <div v-for="(item,index) in orderTechnologyList" :key="index">{{ index+1>9?index+1:"0"+(index+1) }}</div>
                        </div>
                        <div class="name">
                            <div class="orderInfo" v-for="(item,index) in orderTechnologyList" :key="index">
                                <!-- <img :src="item.url" alt=""> -->
                                <div class="imgThree demo-block-preview">
                                            <model-stl
                                                :backgroundAlpha="0"
                                                :rotation="rotation"
                                                :src="item.url.toLowerCase()">
                                            </model-stl>
                                        </div>

                                <div class="infoContent">
                                    <div class="infoName" :title="item.name">{{ item.name }}</div>
                                    <div class="infoOther">表面积：{{ item.longSize }}*{{ item.widthSize }}*{{ item.heightSize }}</div>
                                    <div class="infoOther">体&nbsp;&nbsp;积：{{ item.volume }} mm³</div>
                                    <div class="infoOther">缩&nbsp;&nbsp;放：{{ item.scale }} & </div>
                                </div>
                            </div>
                        </div>
                        <div class="explain">
                            <div class="argumentsName"><span>打印工艺：</span>{{ printOrderInfo.technologyName }}</div>
                            <div class="argumentsName"><span>打印材料：</span>{{ printOrderInfo.firstMaterialName }}/{{ printOrderInfo.secondMaterialName }}</div>
                            <div class="argumentsName"><span>空心：</span>{{ printOrderInfo.soildUuid=='YES'?'是':'否' }}</div>
                            <div class="argumentsName"><span>后处理：</span>{{ printOrderInfo.isReprocess=='YES'?'是':'否' }}</div>
                            <div class="argumentsName" v-if="printOrderInfo.isReprocess=='YES'"><span>后处理类型：</span>{{ printOrderInfo.typeName }}</div>
                            <div class="argumentsName" v-if="printOrderInfo.isReprocess=='YES'"><span>表面效果：</span>{{ printOrderInfo.surfaceEffectName }}</div>
                            <div class="argumentsName" v-if="printOrderInfo.isReprocess=='YES'"><span>备注：</span>{{ printOrderInfo.printContent }}</div>
                            <div class="argumentsName" v-if="printOrderInfo.isReprocess=='YES'"><span>说明文件：</span>
                                <div class="content">
                                    <ul>
                                        <li v-for="(item,index) in orderInfoDetail.fileList" :key="index">{{item.fileName}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="price">
                            <div v-for="(item,index) in orderTechnologyList" :key="index">
                                ¥ {{ item.unitPrice }}
                            </div>
                        </div>
                        <div class="num">
                            <div v-for="(item,index) in orderTechnologyList" :key="index">
                                {{ item.printNum }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--商品价格-->
            <div class="commodityPrices">
                <div class="priceItem">
                    <div class="name">商品总价：</div>
                    <div class="content">¥ {{ printOrderInfo.sumPrice }}</div>
                </div>
                <div class="priceItem">
                    <div class="name">运费：</div>
                    <div class="content">¥ {{ orderInfoDetail.transportationPrice }}</div>
                </div>
                <div class="priceItem fontWeight">
                    <div class="name">实付款：</div>
                    <div class="content">¥ {{ orderBase.totalPrice }}</div>
                </div>
            </div>
            <!--功能按钮-->
            <div class="functionButton" v-if="type !== 'evaluate'">
                <!--功能按钮-->
                <div class="functionButton">
                    <el-button type="primary" v-show="processStatus === 'UN_CONFIRM'" @click="updateAddress(uuid)">修改地址</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_PAY'" @click="submitPay">付款</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_CONFIRM' || processStatus === 'UN_PAY' || processStatus === 'OFFLINE_UN_CONFIRM' || processStatus === 'DELIVERY_ON_CASH_UN_CONFIRM'" @click="cancelOrder(uuid)">取消订单</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_RECEIVE'" @click="takeDelivery(uuid)">确认收货</el-button>
                    <el-button type="primary" v-show="processStatus === 'UN_APPRAISE'" @click="evaluateInfo(uuid)">评价</el-button>
                    <el-button type="primary" v-show="processStatus !== 'UN_CONFIRM'
                    && processStatus !== 'UN_PAY'
                    && processStatus !== 'UN_CANCEL'
                    && processStatus !== 'OFFLINE_UN_CONFIRM'
                    && processStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && (orderBase.afterSaleUuid===null || (orderBase.afterSaleUuid!==null&&orderBase.afterSaleAuditStatus==='REJECT'))
                    && orderBase.splitStatus === 'NONE'
                    && processStatus !== 'AFTER_SALES'"
                               @click="AfterSales(orderBase.uuid,printOrderInfo.enterPriseId,printOrderInfo.enterPriseName,processStatus,orderBase.totalPrice)">申请售后</el-button>
                    <el-button type="primary" v-show="processStatus !== 'UN_CONFIRM'
                    && processStatus !== 'UN_PAY'
                    && processStatus !== 'UN_CANCEL'
                    && processStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                    && orderBase.afterSaleAuditStatus !== 'PASS'
                    && printOrderInfo.issueInvoiceType === null
                    && processStatus !== 'AFTER_SALES'"
                               @click="openInvoice(uuid)">申请开票</el-button>
                    <el-button type="primary" v-if="processStatus === 'OFFLINE_UN_CONFIRM' || processStatus === 'UN_SEND' || processStatus === 'UN_RECEIVE' || processStatus === 'UN_APPRAISE' || processStatus === 'AFTER_SALES' || processStatus === 'FINISHED'" @click="complain(orderBase.uuid,printOrderInfo.enterPriseId,printOrderInfo.enterPriseName)">投诉</el-button>

                </div>
            </div>
        </div>

        <!--修改地址-->
        <edit-address ref="editAddressRef" @editAddressSuccess="getPrintOrderDetail()"></edit-address>

        <!-- 取消订单 -->
        <cancel-order ref="cancelOrderRef" @cancelOrderSuccess="getPrintOrderDetail()"></cancel-order>

        <!-- 申请开票 -->
        <invoice-address ref="invoiceAddressRef" @invoiceAddressSuccess="getPrintOrderDetail()"></invoice-address>

        <!-- 评价 -->
        <evaluate-order ref="evaluateOrderRef" @evaluateOrderSuccess="getPrintOrderDetail()"></evaluate-order>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>

        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef" @refreshData="getPrintOrderDetail"/>

        <!-- 申请售后 -->
        <after-sales-dialog
            ref="afterSalesDialog"
        ></after-sales-dialog>

        <!-- 付款方式 -->
        <TermsOfPayment ref="termsOfPaymentRef" @offlinePay="offlinePayOrder"/>
        <!-- 投诉弹窗 -->
        <complaints-dialog
            ref="dialogRef"
        ></complaints-dialog>
    </div>
</template>

<script>
    import editAddress from './editAddress';
    import cancelOrder from "./cancelOrder";
    import invoiceAddress from "./invoiceAddress";
    import evaluateOrder from "./evaluateOrder";
    import {
        getPrintOrderDetail, updateOrderBaseInfo, getDictionaryItemDetail,
        findBuyerPrintOrderDetail, getAddressDetail, findInvoiceInfo, getRongCloudUser,
        getLogisticsTrack,getDictionaryItem, offlinePay, deliveryOnCash,
    } from '../../../utils/interface';
    import chatDialog from "../../../components/chat/chatDialog";
    import afterSalesDialog from "./afterSalesDialog";
    import PayModelDialog from "./payModelDialog";
    import {getIssueInvoiceByOrderId} from  '../../../utils/issueInvoice';
    import ModelStl from 'vue-3d-model/src/model-stl'
    import TermsOfPayment from '../../../components/termsOfPayment/termsOfPayment'
    import complaintsDialog from './complaintsDialog'
    export default {
        name: "printOrderDetails",
        data() {
            return {
                rotation: {
                    x: 200,
                    y: 0,
                    z: 100,
                },
                processStatus: '',
                processList: [
                    {
                        id: 'UN_CONFIRM',
                        name: '卖家确认'
                    },
                    {
                        id: 'UN_PAY',
                        name: '订单支付'
                    },
                    {
                        id: 'UN_SEND',
                        name: '卖家发货'
                    },
                    {
                        id: 'UN_RECEIVE',
                        name: '确认收货'
                    },
                    {
                        id: 'UN_APPRAISE',
                        name: '评价'
                    },
                    {
                        id: 'FINISHED',
                        name: '完成'
                    },
                ],
                processList1: [
                    {
                        id: 'UN_CONFIRM',
                        name: '卖家确认'
                    },
                    {
                        id: "OFFLINE_UN_CONFIRM",
                        name: "线下支付待确认",
                    },
                    {
                        id: 'UN_PAY',
                        name: '订单支付'
                    },
                    {
                        id: 'UN_SEND',
                        name: '卖家发货'
                    },
                    {
                        id: 'UN_RECEIVE',
                        name: '确认收货'
                    },
                    {
                        id: 'UN_APPRAISE',
                        name: '评价'
                    },
                    {
                        id: 'FINISHED',
                        name: '完成'
                    },
                ],
                processList2: [
                    {
                        id: 'UN_CONFIRM',
                        name: '卖家确认'
                    },
                    {
                        id: "DELIVERY_ON_CASH_UN_CONFIRM",
                        name: "货到付款待确认",
                    },
                    {
                        id: 'UN_PAY',
                        name: '订单支付'
                    },
                    {
                        id: 'UN_SEND',
                        name: '卖家发货'
                    },
                    {
                        id: 'UN_RECEIVE',
                        name: '确认收货'
                    },
                    {
                        id: 'UN_APPRAISE',
                        name: '评价'
                    },
                    {
                        id: 'FINISHED',
                        name: '完成'
                    },
                ],
                day: 0,
                hr: 0,
                min: 0,
                sec: 0,
                uuid:"",
                printOrderInfo:"",
                orderBase:"",
                orderInfoDetail:"",
                receipt:"",
                orderTechnologyList:[],
                payeeInfo:"",
                payeeDetail:"",
                invoiceInfo:"",
                type: '',
                issueInvoice:{},
                logisticsCompanyList: [],
                logisticsList: [],
                logisticsUuid: '',
                logisticsNo: '',
                logisticsCompany:'',
                logisticsTrackVisible: true,
                logisitcsResult:"",
                cancelReason:"",
                order:{},
            }
        },
        created(){
            this.uuid = this.$route.params.uuid;
            this.type = this.$route.params.type;
            this.getPrintOrderDetail();
            this.getLogisticsCompanyList()
        },
        components: {
            cancelOrder,
            editAddress,
            invoiceAddress,
            evaluateOrder,
            chatDialog,
            afterSalesDialog,
            ModelStl,
            PayModelDialog,
            TermsOfPayment,
            complaintsDialog,
        },
        mounted() {
            this.countdown()
        },
        methods: {
            //投诉
            complain(orderBaseUuid, targetUserUuid, enterPriseName) {
                this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
            },
            // 评价
            evaluateInfo(uuid) {
                this.$refs.evaluateOrderRef.init(this.printOrderInfo);
            },
            // 申请开票
            openInvoice(uuid){
                this.$refs.invoiceAddressRef.init(this.printOrderInfo.printOrderUuid,this.orderBase.uuid)
            },
            // 收货
            takeDelivery(uuid){
                this.$confirm('是否确认收货?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.orderBase.orderStatus = "UN_APPRAISE";
                    updateOrderBaseInfo(this.orderBase).then((res)=>{
                        if(res.success){
                            this.$message.success('收货成功！');
                            this.getPrintOrderDetail();
                        }
                    });

                });
            },
            // 支付订单
            submitPay(){
                // 付款的选择弹窗
                this.$refs.termsOfPaymentRef.init()
                /*updateOrderBaseInfo({uuid:this.orderBase.uuid,orderStatus:"UN_SEND"}).then((res)=>{
                    if(res.success){
                        this.$message.success('订单支付成功！');
                        this.getPrintOrderDetail();
                    }
                });*/
            },
            //线下支付上传凭证
            offlinePayOrder(obj){
                if(obj.radio == 1){
                    this.$refs.payModelRef.init();
                    window.open(this.$url.payUrl + this.orderBase.orderNo, "_blank");
                } else if(obj.radio == 2 && obj.imageUrl != '' && obj.imageUrl != null){
                    let form ={orderNo: this.orderBase.orderNo, orderBaseUuid: this.orderBase.uuid, payTicket: obj.imageUrl};
                    offlinePay(form).then(res=> {
                        console.log(res);
                        if (res && res.success) {
                            this.$message.success(res.message);
                            this.getPrintOrderDetail();
                        }else {
                            this.$message.error(res.message);
                        }
                    });
                } else if(obj.radio == 3){
                    let form ={orderNo: this.orderBase.orderNo, orderBaseUuid: this.orderBase.uuid};
                    deliveryOnCash(form).then(res=> {
                        console.log(res);
                        if (res && res.success) {
                            this.$message.success(res.message);
                            this.getPrintOrderDetail();
                        }else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            // 取消订单
            cancelOrder(uuid){
                this.$refs.cancelOrderRef.init(this.printOrderInfo.printOrderUuid,this.orderBase.uuid)
            },
            // 修改地址
            updateAddress(uuid){
                this.$refs.editAddressRef.init(this.printOrderInfo.printOrderUuid,this.printOrderInfo.takeOverUuid)
            },
            getPrintOrderDetail(){
                let params = {
                    uuid:this.uuid
                };
                getPrintOrderDetail(params).then((res)=>{
                    if(res) {
                        this.printOrderInfo = res;
                        this.printOrderInfo.sumPrice = Number(Number(res.orderBase.totalPrice) - Number(res.transportationPrice)).toFixed(2);
                        this.processStatus = res.orderBase.orderStatus;
                        this.orderBase = res.orderBase;
                        // 时间倒计时
                        if(this.orderBase.orderTimeType!=null&&this.orderBase.timeValue){
                            this.getDay(this.orderBase.orderTimeType);
                        }
                        // 取消原因
                        if(this.orderBase.cancelOrderUuid!=null){
                            getDictionaryItemDetail(this.orderBase.cancelOrderUuid).then((res)=>{
                                if(res){
                                    this.cancelReason = res.name;
                                }
                            });
                        }
                        //物流信息
                        if(this.orderBase.logisticsNo!=null&&this.orderBase.logisticsUuid!=null) {
                            this.viewLogisticsInfo(this.orderBase.uuid);
                        }
                        findBuyerPrintOrderDetail({uuid:res.printOrderUuid}).then((res)=>{
                            if(res){
                                this.orderInfoDetail = res.data;
                                this.orderTechnologyList = res.data.technologyList;
                                // 查询收货地址
                                if(res.data.takeOverUuid!=null){
                                    getAddressDetail({uuid:res.data.takeOverUuid}).then((res)=>{
                                        this.payeeDetail = res;
                                    });
                                }

                                // 开票信息
                                getIssueInvoiceByOrderId(this.orderBase.uuid).then((res)=>{
                                    this.issueInvoice = res.data;
                                    console.log("issueInvoice="+JSON.stringify(res.data));
                                    if(res.success){
                                        if(this.issueInvoice.payeeUuid!=null){
                                            getAddressDetail({uuid:this.issueInvoice.payeeUuid}).then((res)=>{
                                                console.log("1="+JSON.stringify(res))
                                                this.payeeInfo = res;
                                            });
                                        }
                                        // 收票地址信息
                                        if(this.issueInvoice.invoiceUuid!= null){
                                            findInvoiceInfo({uuid:this.issueInvoice.invoiceUuid}).then((res)=>{
                                                console.log("2="+JSON.stringify(res))
                                                this.invoiceInfo = res;
                                            });
                                        }
                                    }
                                });
                            }
                        });

                    }
                });
            },
            // 选择确认后
            handleConfirm() {
                console.log("jjj");
            },
            getDay(timeType){
                if(timeType==='HOUR'){
                    let editDate = new Date(this.orderBase.editDate);
                    let countdownTime = editDate.getTime() + 1000 * 60 * 60 * Number(this.orderBase.timeValue);
                    editDate.setTime(countdownTime);
                    let tYear = editDate.getFullYear();
                    let tMonth = editDate.getMonth();
                    let tDate = editDate.getDate();
                    let getHours = editDate.getHours();
                    let getMinutes = editDate.getMinutes();
                    let getSeconds = editDate.getSeconds();
                    tMonth = this.doHandleMonth(tMonth + 1);
                    tDate = this.doHandleMonth(tDate);
                    let date = tYear + '-' + tMonth + '-' + tDate + ' ' + getHours + ':' + getMinutes + ':' + getSeconds;
                    this.countdown(date);
                }
            },
            doHandleMonth (month) {
                let m = month;
                if (month.toString().length === 1) {
                    m = '0' + month
                }
                return m
            },
            // 倒计时
            countdown(date) {
                // 定义结束时间戳
                let end = new Date(date);
                // 定义当前时间戳
                let now = new Date();
                // 做判断当倒计时结束时都为0
                if (now >= end) {
                    this.day = 0;
                    this.hr = 0;
                    this.min = 0;
                    this.sec = 0;
                    return
                }
                // 用结束时间减去当前时间获得倒计时时间戳
                let msec = end - now;
                //算出天数
                let day = parseInt(msec / 1000 / 60 / 60 / 24);
                //算出小时数
                let hr = parseInt(msec / 1000 / 60 / 60 % 24);
                //算出分钟数
                let min = parseInt(msec / 1000 / 60 % 60);
                //算出秒数
                let sec = parseInt(msec / 1000 % 60);
                //给数据赋值
                this.day = day;
                this.hr = hr > 9 ? hr : '0' + hr;
                this.min = min > 9 ? min : '0' + min;
                this.sec = sec > 9 ? sec : '0' + sec;
                setTimeout(()=> {
                    //this.countdown(date);
                    this.getDay(this.orderBase.orderTimeType);
                }, 1000)
            },
            startChat(targetUuid) {
                let user = this.$store.state.userMessages;
                getRongCloudUser(targetUuid).then(res=> {
                    console.log(res);
                    this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
                });
            },
            // 申请售后
            AfterSales(orderBaseUuid, targetUserUuid, enterPriseName, orderStatus, orderPrice){
                this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName, 'PRINT', orderStatus, orderPrice)
            },
            getLogisticsCompanyList(){
                getDictionaryItem({groupCode:'delivery_type'}).then(res=>{
                    this.logisticsCompanyList=res;
                });
            },
            // 查看实时物流
            viewLogisticsInfo(uuid,logisticsNo,logisticsUuid){

                this.logisticsList=[]
                this.logisticsUuid=''
                this.logisticsNo= ''
                this.logisticsCompany=''

                let params = {
                    uuid:uuid,
                    logisticsNo:logisticsNo,
                    logisticsUuid:logisticsUuid
                };
                getLogisticsTrack(params).then((res)=>{
                    if(res.success){
                        if(res.data.status === '200'){
                            //接口查询成功
                            this.logisticsTrackVisible = false;
                            this.logisticsNo = res.data.nu;
                            this.logisticsCompany = this.logisticsCompanyList.find(i => i.code === res.data.com)
                            this.logisticsList = res.data.data
                        }else{
                            this.logisticsTrackVisible = false;
                            this.logisitcsResult = res.data.message;
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            })
                        }
                    }else{
                        this.logisticsTrackVisible = true;
                    }
                });

            },
        },
    }
</script>

<style scoped lang="less">
    p {
        margin: 0;
    }
    i {
        font-style: normal;
    }
    .printOrderDetails {
        background: #f5f5f5;
        // 订单状态
        .detailsState {
            background: #fff;
            font-size: 14px;
            padding: 26px 32px;
            margin-bottom: 8px;
            .detailsState_one {
                display: flex;
                align-items: center;
                position: relative;
                &:nth-of-type(1) {
                    margin-bottom: 16px;
                }
                i {
                    font-size: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                    position: absolute;
                    left: -24px;
                }
                span{
                    color: rgba(0,0,0,.5);
                }
                .detailsState_one_title {
                    font-size: 16px;
                    font-weight: 700;
                    margin-right: 8px;
                }
                .detailsState_one_time {
                    color: #1890ff;
                }
            }
        }
        // 报价流程
        .details {
            background: #fff;
            padding: 0 8px 150px;
            .detailsProcess {
                border-bottom: 1px solid #efefef;
                display: flex;
                align-items: center;
                .processItem{
                    display: flex;
                    align-items: center;
                    /*  cursor: pointer;
                      &:hover{
                          .process_type{
                              i {
                                  background: #1890ff;
                                  color: #fff;
                                  border: 1px solid #1890ff;
                              }
                              p {
                                  color: #000;
                              }
                          }
                      }*/
                }
                .process_type {
                    width: 170px;
                    height: 64px;
                    // line-height: 64px;
                    display: flex;
                    align-items: center;
                    // border-bottom: 2px solid #1890ff;
                    text-align: center;
                    justify-content: center;
                    i {
                        display: inline-block;
                        width: 24px;
                        height: 24px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 50%;
                        color: rgba(0, 0, 0, 0.15);
                        line-height: 27px;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .typeIcon {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                }
                .process_type2 {
                    border-bottom: 3px solid #1890ff;
                    i {
                        background: #1890ff;
                        color: #fff;
                        border: 1px solid #1890ff;
                    }
                    p {
                        color: #000;
                    }
                }
            }

            //发票信息样式
            .invoiceCenter{
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    color: rgba(0, 0, 0, 0.85);
                    font-size: 16px;
                }
                .goodsItem{
                    display: flex;
                    font-size: 14px;
                    padding-bottom: 14px;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .basicInformation{
                display: flex;
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .goodsItem{
                    display: flex;
                    padding-bottom: 14px;
                    font-size: 14px;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                        min-width: 80px;
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
                .goodsReceiving{
                    width: 50%;
                    padding-right: 32px;
                    // border-right: 1px solid #ddd;
                }
                .invoiceInformation{
                    width: 50%;
                    padding-left:32px;
                }
            }
            .logisticsInformation{
                padding: 25px 32px;
                // padding-left: 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .logisticsContent{
                    display: flex;
                    .logisticsLeft{
                        /deep/.el-timeline-item__wrapper{
                            padding-left: 80px;
                        }
                        .timelineItemActive{
                            /deep/.el-timeline-item__timestamp{
                                color: #1890FF;
                            }
                            .content{
                                color: #1890FF;
                            }
                            .timelineItemClass{
                                position: relative;
                                button{
                                    position: absolute;
                                    left: -58px;
                                    top: -21px;
                                    width: 44px;
                                    height: 24px;
                                    background: #1890FF;
                                    border-radius: 2px;
                                    padding: 0;
                                    text-align: center;
                                    line-height: 24px;
                                    color: #fff;
                                    font-size: 12px;
                                    border: none;
                                    cursor: default;
                                }
                            }
                        }
                        .timelineItemClass{
                            font-size: 14px;
                        }
                        /deep/.el-timeline-item{
                            padding-bottom:30px;
                        }
                    }
                }
            }
            .orderInformation{
                padding: 25px 32px;
                border-bottom: 1px solid #ddd;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .orderTop{
                    display: flex;
                    .orderItem{
                        padding-left: 50px;
                        i{
                            color: #1890FF;
                            padding-left: 10px;
                            cursor: pointer;
                        }
                    }
                }
                .orderBottom{
                    display: flex;
                    .orderItem{
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                    }
                }
                .orderItem{
                    font-size: 14px;
                    display: flex;
                    // width: 20%;
                    .name{
                        color: rgba(0, 0, 0, 0.85);
                    }
                    .content{
                        color: rgba(0, 0, 0, 0.65);
                    }
                }
            }
            .printInformation{
                padding: 25px 32px;
                border-bottom: 2px dashed #000;
                h3{
                    margin: 0;
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 24px;
                    padding-bottom: 20px;
                }
                .printTableContent{
                    .tableHeader{
                        display: flex;
                        height: 54px;
                        background:rgba(0,0,0,.02);
                        line-height: 54px;
                        font-size: 14px;
                        color: #000000;
                    }
                    .tableBody{
                        display: flex;
                        align-items: center;
                        .name{
                            text-align: left;
                        }
                        .explain {
                            padding: 20px;
                        }
                        .sort,.price,.num{
                            div{
                                line-height: 204px;
                            }
                        }
                        .price{
                            color: #E42424;
                        }
                        .argumentsName {
                            padding-bottom: 8px;
                            font-size: 14px;
                            span{
                                color: rgba(51, 51, 51, 0.85);
                            }
                        }
                    }
                    .orderInfo {
                        padding: 50px 20px;
                        display: flex;
                        justify-content: center;
                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }
                        .imgThree {
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 550px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }
                    .sort{
                        width: 60px;
                        text-align: center;
                        padding: 0 10px;
                    }
                    .name{
                        flex: 1;
                        text-align: center;
                        padding: 0 10px;
                        min-width: 600px;
                    }
                    .explain{
                        text-align: left;
                        padding: 0 10px;
                        width: 400px;
                    }
                    .price{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                    .num{
                        text-align: center;
                        padding: 0 10px;
                        width: 150px;
                    }
                }
            }
            .commodityPrices{
                padding: 20px 30px 0 0;
                .priceItem{
                    display: flex;
                    justify-content: flex-end;
                    padding-bottom: 15px;
                    font-size: 14px;
                    color: #404040;
                    .content{
                        min-width: 100px;
                        text-align: right;
                    }
                    &.fontWeight{
                        font-weight: 700;
                        .content{
                            color: #FF375F;
                        }
                    }
                }
            }
            .functionButton{
                position: fixed;
                bottom: 20px;
                right: 30px;
            }
        }
    }
    .billingInformation{
        .title{
            color: rgba(0, 0, 0, 0.85);
            padding: 5px 0 10px 15px;
            border-bottom: 1px solid #ddd;
            font-weight: 700;
        }
        .billingContent{
            padding: 10px 10px 0;
            color: rgba(0, 0, 0, 0.65);
            .billingItem{
                display: flex;
                padding-bottom: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/printOrderDetails.vue